import type { Observer } from '@naturehouse/nh-essentials/lib/architecture/ObserverPattern';
import type AbstractSubject from '@naturehouse/nh-essentials/lib/architecture/ObserverPattern';
import ModalComponent from '../../shared/components/ModalComponent';
import HouseSearchListItems from '../store/HouseSearchListItems';

export default class SearchFiltersModal extends ModalComponent implements Observer {
    constructor(context: ContextInterface) {
        super(context);

        this.keepModalInBackground = true;
    }

    public update(subject: AbstractSubject): void {
        if (!(subject instanceof HouseSearchListItems)) return;

        this.#updateSearchButtonWithResultsCount(subject.total);
    }

    protected onTemplateInstantiation(modalTemplate: HTMLTemplateElement): void {
        super.onTemplateInstantiation(modalTemplate);
        this.setEventListeners();
    }

    private setEventListeners(): void {
        HouseSearchListItems.getInstance().attach(this);
    }

    #updateSearchButtonWithResultsCount(totalHouses: number): void {
        if (!this.modalElement) {
            return;
        }

        const searchButton: HTMLSpanElement | null = this.modalElement.querySelector(
            'button[data-results-counter] > span'
        );

        if (searchButton === null) {
            return;
        }

        searchButton.innerText = totalHouses.toString();
    }

    static getClassName(): string {
        return 'SearchFiltersModal';
    }
}
